import { Injectable } from '@angular/core';
import { ISosLog, SosLog } from '../models/sos-log.model';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from './spinner.service';
import { ToastService } from './toast.service';
import { environment } from '../../environments/environment';
import { IServerResponse, ServerResponse } from '../models/server-response.model';

@Injectable({
  providedIn: 'root'
})
export class SosLogService {

  public loading: boolean = false;
  public sosLogs: SosLog[] = [];

  constructor(
    public authService: AuthService,
    private http: HttpClient,
    public spinnerService: SpinnerService,
    public toastService: ToastService
  ) {}

  /*
   ██████╗ ███████╗████████╗ █████╗ ██╗     ██╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔══██╗██║     ██║
  ██║  ███╗█████╗     ██║   ███████║██║     ██║
  ██║   ██║██╔══╝     ██║   ██╔══██║██║     ██║
  ╚██████╔╝███████╗   ██║   ██║  ██║███████╗███████╗
   ╚═════╝ ╚══════╝   ╚═╝   ╚═╝  ╚═╝╚══════╝╚══════╝

  */
  async getAll(
    neighborhoodId: string
  ) {
    this.loading = true;
    this.sosLogs = [];

    const urlApi = `${environment.urlApi}/neighborhoods/${neighborhoodId}/sos-logs`;

    try {
      const token = await this.authService.getToken();

      const response = await new Promise<ServerResponse<{ sosLogs: ISosLog[] }>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{ sosLogs: ISosLog[] }>>(
            urlApi,
            {
              headers: {
                'content-type': 'application/json',
                'Authorization': token.toString()
              }
            }
          ).subscribe({
            next: (res) => resolve(new ServerResponse(res)),
            error: (err) => {
              if (err.error) {
                resolve(new ServerResponse(err.error));
              } else {
                reject(err);
                this.toastService.show({
                  header: 'Error de servidor',
                  body: `${err}`,
                  classname: 'bg-danger text-white'
                });
              }
            }
          });
        }
      );

      if (response.statusCode === 200) {
        this.sosLogs = response.data!.sosLogs.map(
          sosLog => new SosLog(sosLog)
        );
      } else {
        this.toastService.show({
          header: 'Error de servidor',
          body: `${response.message}`,
          classname: 'bg-danger text-white'
        });
      }

    } catch (error) {
      console.log(error);
      this.toastService.show({
        header: 'Error',
        body: `${error}`,
        classname: 'bg-danger text-white'
      });
    }

    this.loading = false;
  }
  
}
